document.addEventListener("turbolinks:load", function () {
  if (document.getElementById("immersive_assignment_form") == null) {
    return;
  }

  let filterData = {
    topics: [],
    combos: [],
    regions: [],
    types: [],
    search_words: []
  };

  const getAssetCards = function() {
    return Array.from(document.querySelectorAll(".ia_search_option"));
  };

  const getContentPanels = function() {
    return Array.from(document.querySelectorAll(".builder-container__left-tab-panel"));
  };

  const getContentTabs = function() {
    return Array.from(document.querySelectorAll(".builder-container__left-tab"));
  };

  const getVisibleAssetCount = function(panel) {
    if (panel == null) {
      return 0;
    }

    return panel.querySelectorAll(".ia_search_option:not(.hidden)").length;
  };

  const getAssetDataArray = function(asset, key) {
    let dataValue = asset.getAttribute("data-" + key);
    if (dataValue == null || dataValue === "") {
      return [];
    }

    try {
      return JSON.parse(dataValue);
    } catch (e) {
      return [];
    }
  };

  const setVisibility = function(element, isVisible) {
    let target = $(element);
    if (isVisible) {
      if (target.hasClass("hidden")) {
        target.removeClass("hidden");
      }
    } else {
      if (!target.hasClass("hidden")) {
        target.addClass("hidden");
      }
    }
  };

  const updateTabCounts = function() {
    getContentTabs().forEach((tabButton) => {
      const panel = document.getElementById(tabButton.dataset.tabTarget);
      const countElement = tabButton.querySelector(".builder-container__left-tab-count");
      if (countElement != null) {
        countElement.textContent = getVisibleAssetCount(panel);
      }
    });
  };

  const setTabSelectedState = function(tabButton, isSelected) {
    const selectedIcon = tabButton.querySelector(".builder-container__left-tab-icon_selected");
    const unselectedIcon = tabButton.querySelector(".builder-container__left-tab-icon_unselected");

    tabButton.classList.toggle("builder-container__left-tab_unselected", !isSelected);
    tabButton.setAttribute("aria-selected", isSelected ? "true" : "false");

    if (selectedIcon != null) {
      selectedIcon.classList.toggle("builder-container__left-tab-icon_hidden", !isSelected);
    }

    if (unselectedIcon != null) {
      unselectedIcon.classList.toggle("builder-container__left-tab-icon_hidden", isSelected);
    }
  };

  const selectContentTab = function(selectedPanelId) {
    getContentTabs().forEach((tabButton) => {
      setTabSelectedState(tabButton, tabButton.dataset.tabTarget === selectedPanelId);
    });

    getContentPanels().forEach((panel) => {
      setVisibility(panel, panel.id === selectedPanelId);
    });
  };

  const shouldShowAsset = function(asset) {
    let shouldShow = true;
    // Check if we have any combos selected. If we do, these take priority over topics.
    if (filterData.combos.length > 0) {
      shouldShow = getAssetDataArray(asset, "combos").some(combo => filterData.combos.indexOf(combo) >= 0);
      if (!shouldShow) {
        return false;
      }
      // Otherwise check if any topics are selected.
    } else if (filterData.topics.length > 0) {
      shouldShow = getAssetDataArray(asset, "topics").some(topic => filterData.topics.indexOf(topic) >= 0);
      if (!shouldShow) {
        return false;
      }
    }
    // Check if any regions are selected.
    if (filterData.regions.length > 0) {
      shouldShow = getAssetDataArray(asset,"regions").some(region => filterData.regions.indexOf(region) >= 0);
      if (!shouldShow) {
        return false;
      }
    }
    if (filterData.types.length > 0) {
      shouldShow = filterData.types.indexOf($(asset).data("asset-type")) >= 0;
      if (!shouldShow) {
        return false;
      }
    }
    // Check if any search words are entered.
    if (filterData.search_words.length > 0) {
      // Grab the list of the asset's search terms, joined into one string
      let assetSearchTerms = getAssetDataArray(asset, "search-terms").join(" ").toLowerCase();
      shouldShow = filterData.search_words.every((searchWord) => assetSearchTerms.includes(searchWord));
    }
    return shouldShow;
  };

  const filterAssets = function() {
    const assetCards = getAssetCards();
    const matchingAssets = assetCards.filter((asset) => shouldShowAsset(asset));

    assetCards.forEach((asset) => {
      setVisibility(asset, matchingAssets.includes(asset));
    });

    updateTabCounts();
  };

  const showClearIcon = function() {
    $("#ia-search-submit").hide();
    $("#ia-search-reset").show();
  };

  const showSearchIcon = function() {
    $("#ia-search-submit").show();
    $("#ia-search-reset").hide();
  };

  const searchDelay = function(fn, delay = 200) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const setupEvents = function() {
    $("#ia-live-search-input-field").on("keyup", searchDelay(function () {
      let searchString = $(this).val().toLowerCase().replace(/[,\/#!$%\^&\*;:{}=\-_`~()]/g, " ");
      filterData.search_words = searchString.split(" ").filter((word) => word.length > 0);
      filterAssets();

      if (searchString.length > 0) {
        showClearIcon();
      } else {
        showSearchIcon();
      }
    }, 150));

    // Event that handles when a filter option is toggled.
    $(".builder-filters .filter-dropdown-option .filter-checkbox").on("change", function() {
      let $option = $(this);
      handleFilterOptionSelected($option.data("type"));
      let headerType = $option.data("header");
      if (headerType != null) {
        let $header = $("#builder-filter-option-header-" + headerType);
        let checkedOptions = $header
          .closest(".filter-dropdown__body-contents")
          .find(".filter-dropdown-option .filter-checkbox[data-header=" + headerType + "]:checked");
        let totalOptions = $header
          .closest(".filter-dropdown__body-contents")
          .find(".filter-dropdown-option .filter-checkbox[data-header=" + headerType + "]");
        $header.prop("checked", checkedOptions.length === totalOptions.length);
      }
    });

    $(".builder-filters .filter-dropdown-option-header .filter-checkbox").on("change", function() {
      let $checkboxOption = $(this);
      let headerId = $checkboxOption.data("id");
      let headerType = $checkboxOption.data("type");
      let headerChecked = $checkboxOption.is(":checked");

      let optionsToCheck;
      if (headerChecked) {
        optionsToCheck = $checkboxOption
          .closest(".filter-dropdown__body-contents")
          .find(".filter-dropdown-option .filter-checkbox[data-header=" + headerId + "]")
          .not(":checked");
      } else {
        optionsToCheck = $checkboxOption
          .closest(".filter-dropdown__body-contents")
          .find(".filter-dropdown-option .filter-checkbox[data-header=" + headerId + "]:checked")
      }
      optionsToCheck.each((index) => {
        $(optionsToCheck[index]).prop("checked", headerChecked);
      })
      handleFilterOptionSelected(headerType);
    });

    $("#filters-counter-reset-button").on("click", function() {
      handleFilterOptionSelected(null);
      $("#filter-dropdown-subtopic").prop("inert", true);
    });
    setupBuilderFilterCheckboxEvents();

    $("#ia-search-reset").on("click", function () {
      $("#ia-live-search-input-field").val("");
      filterData.search_words = [];
      filterAssets();
      showSearchIcon();
    });

    getContentTabs().forEach((tabButton) => {
      tabButton.addEventListener("click", function () {
        selectContentTab(tabButton.dataset.tabTarget);
      });
    });
  };

  const showPreviewSpinner = function(e) {
    const previewButton = e.target.closest("button");
    previewButton.disabled = true;

    setTimeout(() => {
      const previewModal = $("#preview-contentful-asset-modal");
      if (previewModal.length === 0) {
        $(".ia-spinner-modal").show();
      }
      previewButton.disabled = false;
    }, 200);
  };

  const intersectingCombos = function(selectedTopicsQuery, selectedSubtopicsQuery) {
    let selectedTopicCombos = [].concat.apply(
      [],
      selectedTopicsQuery.toArray().map(option => $(option).data('combos'))
    );
    const selectedSubtopicCombos = [].concat.apply(
      [],
      selectedSubtopicsQuery.toArray().map(option => $(option).data('combos'))
    );
    return selectedTopicCombos.filter(combo => selectedSubtopicCombos.includes(combo));
  };

  const selectedIds = (selectedFilterQuery) => {
    return selectedFilterQuery.toArray().map(option => $(option).data('id'));
  };

  const handleFilterOptionSelected = function(type){
    let selectedTopicsQuery = $("#filter-dropdown-topic .filter-dropdown-option :checked");
    let selectedSubtopicsQuery = $("#filter-dropdown-subtopic :checked");
    let selectedRegionsQuery = $("#filter-dropdown-region :checked");

    switch (type) {
      // We selected a topic.
      case "topic":
        // Check if we have any topics selected and set the subtopic dropdown state accordingly.
        let selectedTopics = selectedTopicsQuery.toArray().map(option => $(option).data("id"));
        let $subtopicDropdown = $("#filter-dropdown-subtopic");

        // There are now no topics selected.
        // We need to disable the subtopic button and uncheck any checked subtopics.
        if (selectedTopics.length <= 0) {
          $subtopicDropdown.prop("inert", true);
          selectedSubtopicsQuery.each(function () {
            $(this).prop("checked", false).trigger("change");
          });
          // We have some selected topics.
          // We need to enable the subtopic button and reveal all related subtopics.
        } else {
          $subtopicDropdown.prop("inert", false);
          let selectedCombos = [].concat.apply(
            [],
            selectedTopicsQuery.toArray().map(option => $(option).data('combos'))
          );

          $('#filter-dropdown-subtopic .filter-dropdown__body-contents').children().each(function() {
            let subtopic = $(this);
            let subtopicCheckbox = subtopic.find("input");
            let shouldEnable = subtopicCheckbox.data("combos").some(combo => selectedCombos.indexOf(combo) >= 0);
            if (shouldEnable) {
              setVisibility(subtopic, true);
            } else {
              subtopicCheckbox.prop("checked", false).trigger("change");
              setVisibility(subtopic, false);
            }
          })
          // Set the array of selected topics as the topic filter data.
          filterData.topics = selectedTopics;
        }
        break;

      // We selected a subtopic.
      case "subtopic":
        break;

      // We selected a region.
      case "region":
        break;

      // We selected a type.
      case "type":
        break;
    }
    // Final check for all selected topics.
    filterData.topics = selectedIds(selectedTopicsQuery);
    // Final check for all selected subtopics.
    filterData.combos = intersectingCombos(selectedTopicsQuery, selectedSubtopicsQuery);
    // Final check for all selected regions.
    filterData.regions = selectedIds(selectedRegionsQuery);
    //Final check for all selected types.
    filterData.types = $("#filter-dropdown-type .filter-dropdown-option :checked")
      .toArray()
      .map(option => $(option).data("key"));

    filterAssets();
  };

  // Function that returns sorted keys of the provided dictionary based on the sortKey
  // provided. The values of the provided dictionary keys are also dictionaries. The sortKey
  // references a key within those dictionaries that is used to determine the sort order.
  const getSortedKeys = function(filterDict, sortKey) {
    return Object.keys(filterDict).sort(function (a, b) {
      if (filterDict[a][sortKey] > filterDict[b][sortKey]) {
        return 1
      } else if (filterDict[a][sortKey] < filterDict[b][sortKey]) {
        return -1
      }
      return 0
    })
  };

  const populateFilterOptions = function(data) {
    let dropdownBodyContentsSelector = ".filter-dropdown__body-contents";
    let sortedCategories = Object.keys(data["topics"]);
    sortedCategories.sort(function (a, b) {
      if (a === "none") {
        return 1;
      } else if (b === "none") {
        return -1;
      }

      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
      return 0;
    });

    let topicDropdownMenu = $("#filter-dropdown-topic " + dropdownBodyContentsSelector);
    sortedCategories.forEach((category) => {
      // Add the category as an option.
      if (category !== "none") {
        topicDropdownMenu.append($.parseHTML(data["topics"][category]["html"]));
      }
      // Add all the topics under this category.
      getSortedKeys(data["topics"][category]["topics"], "name").forEach((key) => {
        topicDropdownMenu.append($.parseHTML(data["topics"][category]["topics"][key]["html"]));
      });
    });

    let subtopicDropdownMenu = $("#filter-dropdown-subtopic " + dropdownBodyContentsSelector);
    getSortedKeys(data["subtopics"], "name").forEach((key) => {
      subtopicDropdownMenu.append($.parseHTML(data["subtopics"][key]["html"]));
    });

    let typeDropdownMenu = $("#filter-dropdown-type " + dropdownBodyContentsSelector);
    getSortedKeys(data["types"], "name").forEach((key) => {
      typeDropdownMenu.append($.parseHTML(data["types"][key]["html"]));
    });

    let regionDropdownMenu = $("#filter-dropdown-region " + dropdownBodyContentsSelector);
    getSortedKeys(data["regions"], "name").forEach((key) => {
      regionDropdownMenu.append($.parseHTML(data["regions"][key]["html"]));
    });

    // Subtopic starts disabled.
    let $subtopicDropdown = $("#filter-dropdown-subtopic");
    $subtopicDropdown.prop("inert", true);
  };

  $.ajax({
    url: "/ia/generate_search_data",
    type: "POST",
    dataType: "json",
    success: function (data) {
      for (let i = 0; i < data.response.assets.length; i++) {
        let asset = data.response.assets[i];
        let assetElement = document.getElementById("activity-card-" + asset.id);

        if (assetElement != null && assetElement.dataset != null) {
          assetElement.dataset.topics = JSON.stringify(asset.topics)
          assetElement.dataset.combos = JSON.stringify(asset.combos)
          assetElement.dataset.regions = JSON.stringify(asset.regions)
          assetElement.dataset.searchTerms = JSON.stringify(asset.search_terms);
        }
      }

      populateFilterOptions(data["response"]);
      setupEvents();

      $(".immersive-asset-card__action-button_preview").click(showPreviewSpinner);
      filterAssets();

      $("#ia-builder-loading-spinner").fadeOut();
    },
  });
});
